(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cdk-group-order-inquiry"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('cdk-quote__form')) return;
  const query = new URLSearchParams(window.location.search);
  form.querySelectorAll('[data-cdk-campaign]').forEach((input) => {
    input.value = (query.get(input.dataset.cdkCampaign) || '').replace(/[^a-zA-Z0-9 _.-]/g, '').slice(0, 100);
  });
}, true);
  } catch(e) { console.error(e); }
})();

})();
